module.exports = __webpack_public_path__ + "static/media/21ECLAC52.6b7124c7.jpg";